import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  SUPER_OFFERS,
  APPLY_TO,
  DAILY_SPECIALS,
  setTab
} from 'src/redux/actions/tabs';
import { Tab, Tabs } from '@grupa-pracuj/react-tabs';
import styles from 'src/containers/TabsContainer.scss';


class TabsContainer extends PureComponent {
  setTab = (activeTab) => {
    const { dispatch } = this.props;
    dispatch(setTab({ activeTab }));
  };

  render() {
    const superOffersTitle = 'Superoferty';
    const dailySpecialsTitle = 'Oferty dnia';
    const applyToTitle = 'Znajdź pracę w...';
    const { tab, showApplyToTab } = this.props;
    const tabList = [
      <Tab
        key={ DAILY_SPECIALS }
        id={ DAILY_SPECIALS }
        onClick={ () => this.setTab(DAILY_SPECIALS) }
      >
        {dailySpecialsTitle}
      </Tab>,
      <Tab
        key={ SUPER_OFFERS }
        id={ SUPER_OFFERS }
        onClick={ () => this.setTab(SUPER_OFFERS) }
      >
        {superOffersTitle}
      </Tab>
    ];
    if (showApplyToTab) {
      tabList.push(
        <Tab key={ APPLY_TO } id={ APPLY_TO } onClick={ () => this.setTab(APPLY_TO) }>{applyToTitle}</Tab>
      );
    }
    return (
      <Tabs
        customClasses={ {
          customClass: styles['tabs-container'],
          customWrapper: styles['tabs-wrapper'],
          customUnderline: styles['tabs-underline'],
          customBorder: styles['tabs-border']
        } }
        customTabClasses={ {
          customClass: styles.tab,
          customActiveClass: styles['tab--active']
        } }
        initialActiveTab={ tab }
      >
        {
        tabList.map(element => element)
      }
      </Tabs>
    );
  }
}

TabsContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  showApplyToTab: PropTypes.bool.isRequired,
  tab: PropTypes.string.isRequired
};

const mapStateToProperties = ({ tabs, employers }) => ({
  tab: tabs.activeTab,
  showApplyToTab: employers.list.length > 0
});

export default connect(mapStateToProperties)(TabsContainer);
